import { NOVIDADES_PORTAL_PATH } from "./constants";

/**
 * @param {string} idnovidade
 * @param {{ origin?: string, pathname?: string, search?: string }} [locationLike]
 */
export function buildNovidadeShareUrl(idnovidade, locationLike = {}) {
  if (!idnovidade) return "";

  const origin =
    locationLike.origin != null ? locationLike.origin : "http://localhost";
  const pathname =
    locationLike.pathname != null
      ? locationLike.pathname
      : NOVIDADES_PORTAL_PATH;

  const params = new URLSearchParams(
    locationLike.search ? locationLike.search.replace(/^\?/, "") : ""
  );
  params.set("idnovidade", String(idnovidade));

  const query = params.toString();
  return `${origin}${pathname}${query ? `?${query}` : ""}`;
}
